import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Types} from "components";
import API from "@beardeddevops/react.api";
import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Dispositions',
		url: '/dispositions',
		icon: 'upload',
	}
];

export default class Dispositions extends Framework.Components.View {

	constructor(props) {
		super(props);
	}
	handleSetTotal = (totalCount) => {
		this.setState({totalCount});
	}

	grabDateFilter = async (dateFilter) => {
		let dispositionFiltered = new API.BuildClass(Types.Forms_Results._name, 'GET_DISPOSITION_DATE_FILTERED');
		dispositionFiltered.parent = '9999-99999999';
		dispositionFiltered.filter = dateFilter;
		let result = await dispositionFiltered.submit(null, 'GET_DISPOSITION_DATE_FILTERED');
		if(result){
			this.setState({dispoCount: result.count})
		}
	}

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar
					breadcrumbs={breadcrumbsStatic}
					history={this.props.history}
				>
					<div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
						{this.state.totalCount > 0 && (
							<div style={{
								position: 'absolute',
								right: '50%',
								transform: 'translateX(50%)',
								color: '#666',
								fontSize: '0.9em',
								fontWeight: '500',
								pointerEvents: 'none'
							}}>
								{this.state.totalCount + " total firearms on " + this.state.dispoCount + " ATF form 4473's"}
							</div>
						)}
						<Button data-id="add-disposition" onClick={this.toggle('modalDisposition')} size="sm" color="primary">
							<i className="fa fa-upload"/>&nbsp;&nbsp;Add Disposition
						</Button>
					</div>
				</Framework.Components.PageBar>

				<Collections.Dispositions
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					scannedCode={!this.state['modalDisposition'] ? this.props.scannedCode : null}
					showDateRangeSearch={true}
					setTotalCount={this.handleSetTotal}
					grabDateFilter={this.grabDateFilter}

				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Quick Disposition"
					object={Objects.DispositionAdd}
					history={this.props.history}
					toggle={this.state['modalDisposition']}
					reportClose={this.reportClose('modalDisposition')}
					afterSave={this.handleAfterSave}
					url="dispositions"
					size="xl"
					objectProps={{scannedCode: this.state['modalDisposition'] ? this.props.scannedCode : null}}
				/>

			</div>
		);
	}
}